import { Component, Input } from '@angular/core';
import { StatusEnum } from '@enums/Status';

@Component({
  selector: 'pop-status-chip',
  templateUrl: './status-chip.component.html',
  styleUrls: ['./status-chip.component.less']
})
export class StatusChipComponent {
  @Input({ required: true })
  public status!: string;

  public statusEnum = StatusEnum;
}
